import React from "react";
import "./HomeTestimonials.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";

import { IoIosStar } from "react-icons/io";
import { MdStarHalf } from "react-icons/md";
import {
  HiOutlineArrowNarrowRight,
  HiOutlineArrowNarrowLeft,
} from "react-icons/hi";

export default function HomeTestimonials({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= DATA =================
  const testimonials = [
    {
      name: "Michael R. Collins",
      email: "michael.collins@astraenergygroup.com",
      img: "/assets/images/Person.png",
      rating: 3.5,
      text: "Pestel & Partners provided exceptional clarity during our audit restructuring phase. Their team demonstrated deep technical knowledge, transparent communication, and a genuine commitment to ensuring compliance and operational improvement.",
    },
    {
      name: "Sarah D. Ibrahim",
      email: "sarah.ibrahim@greenleafholdings.com",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "Their financial advisory insights helped us streamline our reporting structure and optimize capital flow across multiple subsidiaries. What stood out was their proactive approach and professionalism throughout every engagement.",
    },
    {
      name: "Daniel M. Ofori",
      email: "daniel.ofori@atlanticlogistics.co.bf",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "As a growing logistics group, we needed a partner who understood regional regulations and global standards. Pestel & Partners exceeded expectations with their precision, responsiveness, and practical solutions.",
    },
    {
      name: "Anita Sharma",
      email: "anita.sharma@vertexretail.in",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "Working with Pestel & Partners gave us confidence in our numbers. Their audit and risk management framework not only improved compliance but also helped us uncover key efficiency gaps across departments.",
    },
    {
      name: "James L. Grant",
      email: "james.grant@novafintech.co.uk",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "The consultants at Pestel & Partners are not just advisors—they act as strategic partners. Their analytical depth and financial foresight have been truly instrumental in effectively and efficiently guiding our expansion decisions.",
    },
  ];

  const testimonialsFr = [
    {
      name: "Michael R. Collins",
      email: "michael.collins@astraenergygroup.com",
      img: "/assets/images/Person.png",
      rating: 3.5,
      text: "Pestel & Partners a apporté une clarté exceptionnelle lors de notre phase de restructuration d’audit. Leur équipe a démontré une expertise technique approfondie, une communication transparente et un engagement réel envers la conformité et l’amélioration opérationnelle.",
    },
    {
      name: "Sarah D. Ibrahim",
      email: "sarah.ibrahim@greenleafholdings.com",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "Leurs conseils en stratégie financière nous ont aidés à rationaliser notre structure de reporting et à optimiser les flux de capitaux entre plusieurs filiales. Ce qui nous a le plus marqués, c’est leur approche proactive et leur professionnalisme à chaque étape.",
    },
    {
      name: "Daniel M. Ofori",
      email: "daniel.ofori@atlanticlogistics.co.bf",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "En tant que groupe logistique en pleine croissance, nous avions besoin d’un partenaire comprenant à la fois les réglementations régionales et les normes internationales. Pestel & Partners a dépassé nos attentes grâce à sa précision, sa réactivité et ses solutions pragmatiques.",
    },
    {
      name: "Anita Sharma",
      email: "anita.sharma@vertexretail.in",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "Collaborer avec Pestel & Partners nous a donné une totale confiance dans nos chiffres. Leur cadre d’audit et de gestion des risques a non seulement renforcé la conformité, mais a également permis d’identifier des axes clés d’amélioration de l’efficacité entre les départements.",
    },
    {
      name: "James L. Grant",
      email: "james.grant@novafintech.co.uk",
      img: "/assets/images/Person.png",
      rating: 4.5,
      text: "Les consultants de Pestel & Partners ne sont pas de simples conseillers — ils agissent comme de véritables partenaires stratégiques. Leur profondeur d’analyse et leur vision financière ont été déterminantes pour orienter nos décisions d’expansion de manière efficace et éclairée.",
    },
  ];

  // ✅ LANGUAGE-SAFE DATA
  const data = isFrench ? testimonialsFr : testimonials;

  // ================= STAR RENDER =================
  const renderStars = (rating) => {
    const stars = [];
    const full = Math.floor(rating);
    const half = rating % 1 !== 0;

    for (let i = 0; i < full; i++) {
      stars.push(<IoIosStar key={i} className="star-full" />);
    }
    if (half) stars.push(<MdStarHalf key="half" className="star-full" />);

    return stars;
  };

  // ================= MOBILE DETECTION =================
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // ================= SLIDES =================
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const slides = chunkArray(data, isMobile ? 1 : 4);

  // ================= UI =================
  return (
    <section className="home-testimonials-section section">
      <div className="text-center">
        <div className="d-flex align-items-center justify-content-center">
          <div className="about-line me-3"></div>
          <p className="service-subtitle mb-0">
            {isFrench ? "EXPÉRIENCES CLIENTS" : "CLIENT EXPERIENCES"}
          </p>
        </div>

        <h2 className="client-heading">
          {isFrench
            ? "CE QUE NOS PARTENAIRES DISENT DE NOUS"
            : "WHAT OUR PARTNERS SAY ABOUT US"}
        </h2>
      </div>

      <div className="carousel-wrapper position-relative testimonial-nav-line">
        <Carousel
          indicators={false}
          controls
          nextIcon={
            <span className="carousel-btn next-btn">
              <HiOutlineArrowNarrowLeft size={20} />
            </span>
          }
          prevIcon={
            <span className="carousel-btn prev-btn">
              <HiOutlineArrowNarrowRight size={20} />
            </span>
          }
        >
          {slides.map((group, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <div className="row justify-content-center g-4 mt-2">
                {group.map((item, i) => (
                  <div key={i} className="col-12 col-sm-6 col-md-6 col-lg-3 mb-2">
                    <div className="test-card">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="client-name">{item.name}</h5>
                          <p className="client-email">{item.email}</p>
                        </div>
                        <img src={item.img} alt={item.name} className="client-img" />
                      </div>

                      <div className="rating-row">
                        {renderStars(item.rating)}
                        <span className="rating-value">{item.rating}</span>
                      </div>

                      <p className="client-text">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
}
